/**
 * Imports
 */

// isMobile
import isMobile from "ismobilejs";

// Smooth Scroll Behavior Polyfill
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

// Swiper
import Swiper, { Pagination, Navigation, Autoplay } from "swiper";
Swiper.use([Pagination, Navigation, Autoplay]);

// Modules
import "./modules/SetWindowHeight.js";
import { slideUp, slideDown, slideToggle } from "./modules/SlideBlock.js";
import BodyScroll from "./modules/BodyScroll.js";
// import CustomSelect from "./modules/CustomSelect.js";
import "./modules/Tabs.js";

/**
 * Initialization
 */

// Body Scroll
const bodyScroll = new BodyScroll();

// Custom Select
// document.querySelectorAll(".custom-select").forEach((item) => {
//   new CustomSelect(item);
// });

document.addEventListener("click", (e) => {
  const activeBtn = document.querySelector(".dropdown-trigger-is-active");

  if (activeBtn) {
    const parent = activeBtn.parentElement;

    if (parent != e.target && !parent.contains(e.target)) {
      activeBtn.click();
    }
  }
});

/**
 * Topbar
 */
const topbar = document.querySelector(".topbar");
if (topbar) {
  const theme = topbar.classList.contains("-light") ? "light" : "dark";
  const backdrop = document.querySelector(".topbar-backdrop");
  const menuTriggers = topbar.querySelectorAll(".topbar-nav > li.has-menu");

  menuTriggers.forEach((trigger) => {
    // const menu = headerNav.querySelector('.header-nav-dropdown')

    trigger?.addEventListener("mouseenter", () => {
      // backdrop.classList.add('active')
      if (window.innerWidth >= 1170) {
        backdrop.classList.add("active");

        if (theme === "light") {
          topbar.classList.remove("-light");
          topbar.classList.add("-dark");
        }
      }
    });

    trigger?.addEventListener("mouseleave", () => {
      // backdrop.classList.remove('active')
      if (window.innerWidth >= 1170) {
        backdrop.classList.remove("active");
        if (theme === "light") {
          topbar.classList.remove("-dark");
          topbar.classList.add("-light");
        }
      }
    });
  });
}

/**
 * Nav
 */
const nav = document.querySelector("nav.header-nav");
if (nav) {
  const subNavTriggers = nav.querySelectorAll(
    "li.menu-item-has-children > button"
  );
  subNavTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      if (window.innerWidth < 1170) {
        trigger.parentElement.classList.toggle("active");
        slideToggle(trigger.nextElementSibling, 300);
      }
    });
  });

  const itemsWithCtaMenu = nav.querySelectorAll("li.has-menu-with-cta");
  itemsWithCtaMenu.forEach((trigger) => {
    trigger?.addEventListener("mouseenter", () => {
      if (window.innerWidth >= 1170) {
        trigger.parentElement.style.position = "relative";
      }
    });
    trigger?.addEventListener("mouseleave", () => {
      if (window.innerWidth >= 1170) {
        trigger.parentElement.style.pointerEvents = "none";
        setTimeout(() => {
          trigger.parentElement.style.removeProperty("position");
          trigger.parentElement.style.removeProperty("pointer-events");
        }, 200);
      }
    });
  });

  const itemsWithBigMenu = nav.querySelectorAll("li.has-big-menu");
  itemsWithBigMenu.forEach((trigger) => {
    trigger?.addEventListener("mouseleave", () => {
      if (window.innerWidth >= 1170) {
        trigger.parentElement.style.pointerEvents = "none";
        setTimeout(() => {
          trigger.parentElement.style.removeProperty("pointer-events");
        }, 200);
      }
    });

    const innerTriggers = trigger.querySelectorAll(".header-big-menu-title");
    innerTriggers.forEach((trigger) => {
      trigger.addEventListener("click", function () {
        if (window.innerWidth < 1170) {
          trigger.classList.toggle("active");
          slideToggle(trigger.nextElementSibling, 300);
        }
      });
    });
  });

  const topbar = document.querySelector(".topbar");
  const header = document.querySelector("header.header");
  const hamburger = document.querySelector(".hamburger");
  hamburger?.addEventListener("click", () => {
    if (hamburger.classList.contains("is-active")) {
      bodyScroll.unLock(300);
      hamburger.classList.remove("is-active");
      nav.classList.remove("active");
      header?.classList.remove("-filled");
    } else {
      if (window.scrollY >= topbar.getBoundingClientRect().height) {
        bodyScroll.lock(nav);
        hamburger.classList.add("is-active");
        nav.classList.add("active");
        header?.classList.add("-filled");
      } else {
        const topbarHeight = topbar
          ? topbar.getBoundingClientRect().height
          : null;

        window.scroll({
          top: topbar ? topbarHeight : 0,
          left: 0,
          behavior: "smooth",
        });

        const a = topbar ? topbarHeight - window.scrollY : window.scrollY;
        const b = a < 0 ? a * -1 : a;

        if (isMobile(window.navigator).apple.device) {
          setTimeout(
            () => {
              bodyScroll.lock(nav);
              hamburger.classList.add("is-active");
              nav.classList.add("active");
              header?.classList.add("-filled");
            },
            window.scrollY == topbarHeight ? 0 : 500
          );
        } else {
          setTimeout(() => {
            bodyScroll.lock(nav);
            hamburger.classList.add("is-active");
            nav.classList.add("active");
            header?.classList.add("-filled");
          }, Math.max(50, b * 1.5));
        }
      }
    }
  });

  //const logo = document.querySelector(".di-logo");
  var contactButton = document.querySelector(".btn-contact");
  var needsToChangeClass = false;

  var scrollChecker = function scrollChecker() {
    if (
      window.scrollY >= topbar.getBoundingClientRect().height &&
      contactButton
    ) {
      header.classList.add("-light", "-sticky");

      if (!contactButton.classList.contains("-orange")) {
        needsToChangeClass = true;
        contactButton.classList.add("-filled", "-orange");
        contactButton.classList.remove("-bordered", "-white");
      }
    } else {
      header.classList.remove("-light", "-sticky");
      if (needsToChangeClass) {
        contactButton.classList.remove("-filled", "-orange");
        contactButton.classList.add("-bordered", "-white");
      }
    }
  };

  scrollChecker();

  window.addEventListener("scroll", () => scrollChecker());
}

/**
 * Header Search
 */
const headereSearch = document.querySelector(".header-search");
if (headereSearch) {
  const input = headereSearch.querySelector("input");
  const trigger = headereSearch.querySelector(".header-search-trigger");
  trigger.addEventListener("click", () => {
    headereSearch.classList.add("active");
    input.focus();
  });

  document.addEventListener("click", (e) => {
    if (headereSearch != e.target && !headereSearch.contains(e.target)) {
      headereSearch.classList.remove("active");
    }
  });
}

/**
 * Hero Slider
 */
new Swiper(".hero-slider", {
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  speed: 500,
  pagination: {
    el: ".slider-pagination",
    clickable: true,
    bulletActiveClass: "active",
    renderBullet: () => {
      return `
                <span class="swiper-pagination-bullet">
                    <svg width="12" height="12" viewBox="0 0 12 12">
                        <circle cx="6" cy="6" r="4.5"/>
                    </svg>
                </span>
            `;
    },
  },
  simulateTouch: false,
  spaceBetween: 15,
  slidesPerView: 1,
});

/**
 * Home Cases Slider
 */
new Swiper(".home-cases-slider", {
  navigation: {
    nextEl: ".home-cases-slider-nav .slider-button.-next",
    prevEl: ".home-cases-slider-nav .slider-button.-prev",
  },
  spaceBetween: 10,
  slidesPerView: 1,
  grabCursor: true,
  breakpoints: {
    768: {
      spaceBetween: 40,
      slidesPerView: 2,
    },
    1170: {
      spaceBetween: 40,
      slidesPerView: 3,
    },
  },
});

/**
 * FAQ
 */
const faqItems = document.querySelectorAll(".faq-item");
faqItems.forEach((item) => {
  const trigger = item.querySelector(".faq-item-trigger"),
    dropdown = item.querySelector(".faq-item-dropdown");

  trigger.addEventListener("click", () => {
    if (!trigger.classList.contains("active")) {
      const activeItemTrigger = document.querySelector(
        ".faq-item-trigger.active"
      );

      if (activeItemTrigger) {
        activeItemTrigger.classList.remove("active");
        slideUp(activeItemTrigger.nextElementSibling, 300);
      }
    }

    trigger.classList.toggle("active");
    slideToggle(dropdown, 300);
  });
});

/**
 * YouTube Embed
 */
const youtubeBlocks = document.querySelectorAll(".youtube-video");
youtubeBlocks.forEach((block) => {
  const source =
    "https://img.youtube.com/vi/" + block.dataset.embed + "/sddefault.jpg";

  const image = new Image();
  image.src = source;
  image.addEventListener("load", () => {
    block.appendChild(image);
  });

  block.addEventListener("click", function () {
    const iframe = document.createElement("iframe");

    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute(
      "src",
      "https://www.youtube.com/embed/" +
        this.dataset.embed +
        "?rel=0&showinfo=0&autoplay=1"
    );

    block.innerHTML = "";
    block.appendChild(iframe);
  });
});

/**
 * Filter
 */
const filterNavs = document.querySelectorAll(".filter-nav");
filterNavs.forEach((nav) => {
  const cardsClass = nav.dataset.cardsClass;
  if (cardsClass) {
    const cards = document.querySelectorAll(`.${cardsClass}`);
    const navItems = nav.querySelectorAll("li");

    navItems.forEach((item) => {
      item.addEventListener("click", () => {
        if (!item.classList.contains("active")) {
          const activeTrigger = nav.querySelector("li.active");
          activeTrigger.classList.remove("active");
          item.classList.add("active");

          const category = item.dataset.category;

          if (category === "all") {
            cards.forEach((card) => card.classList.remove("d-none"));
          } else {
            cards.forEach((card) => {
              const cardCategories = card.dataset.categories;

              if (cardCategories.includes(category)) {
                card.classList.remove("d-none");
              } else {
                card.classList.add("d-none");
              }
            });
          }
        }
      });
    });
  }
});

/**
 * Anchors
 */
const anchors = document.querySelectorAll('a[href*="#"]');
anchors.forEach((anchor) => {
  anchor.addEventListener("click", (e) => {
    const target = document.querySelector(anchor.hash);

    if (target) {
      e.preventDefault();

      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  });
});

/**
 * Article Sidebar
 */
const articleSidebar = document.querySelector(".article-sidebar ul");
if (articleSidebar) {
  const links = articleSidebar.querySelectorAll("a");

  window.addEventListener("scroll", () => {
    const fromTop = Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    );

    links.forEach((link) => {
      const target = document.querySelector(link.hash);

      if (target) {
        if (
          target.offsetTop <= fromTop + 300 &&
          target.offsetTop + target.offsetHeight > fromTop + 300
        ) {
          link.classList.add("active");
        } else {
          link.classList.remove("active");
        }
      }
    });
  });
}

/**
 * Reviews Slider
 */
new Swiper(".reviews-slider", {
  navigation: {
    nextEl: ".reviews-slider-nav .slider-button.-next",
    prevEl: ".reviews-slider-nav .slider-button.-prev",
  },
  spaceBetween: 10,
  slidesPerView: 1,
  grabCursor: true,
  autoHeight: true,
  breakpoints: {
    576: {
      spaceBetween: 15,
      slidesPerView: 1,
    },
    768: {
      spaceBetween: 20,
      slidesPerView: 2,
    },
    1170: {
      spaceBetween: 30,
      slidesPerView: 3,
    },
  },
});

/**
 * Hero Slider
 */
new Swiper(".home-hero-copmanies-slider", {
  pagination: {
    el: ".slider-pagination",
    clickable: true,
    bulletActiveClass: "active",
  },
  simulateTouch: false,
  spaceBetween: 15,
  slidesPerView: 3,
  breakpoints: {
    576: {
      spaceBetween: 15,
      slidesPerView: 3,
    },
    768: {
      spaceBetween: 15,
      slidesPerView: 4,
    },
    992: {
      spaceBetween: 20,
      slidesPerView: 6,
    },
  },
});
